import { tw } from "@careinfo/tailwind";
import { ResponsiveBar } from "@nivo/bar";
import Card from "../Reusable/Card";

const graphTheme = {
  // Tooltip shown while hovering bar
  tooltip: {
    container: {
      background: "var(--primary-light)",
      borderRadius: "5px",
    },
  },
  text: {
    // Value writtrn inside bar
    fontSize: 20,
    fill: "#ffffff",
  },
  axis: {
    legend: {
      // X-axis and Y-axis label
      text: {
        fontSize: 16,
        fill: "var(--primary)",
      },
    },
    domain: {
      //X-axis and Y-axis main line
      line: {
        strokeWidth: 2,
        stroke: "var(--primary-light)",
      },
    },
    ticks: {
      //Small line extending left of y-axis
      line: {
        strokeWidth: 1,
        stroke: "var(--primary-light)",
      },
      //Values of Y-axis
      text: {
        fontSize: 14,
        fill: "var(--primary)",
      },
    },
  },
};

export default function Graph({ data }) {
  return (
    <div className={tw`bg-white w-full`}>
      <Card>
        <div className={tw`flex items-center gap-x-64`}>
          <h2 className={tw`font-bold text-2xl leading-10`}>Cashflow</h2>
          <div className={tw`flex items-center gap-x-16`}>
            <div className={tw` flex items-center gap-x-4`}>
              <div
                className={tw`h-4 w-4 rounded-sm`}
                style={{
                  background: "var(--primary)",
                }}
              />
              <p>Cash In</p>
            </div>
            <div className={tw` flex items-center gap-x-4`}>
              <div
                className={tw`h-4 w-4 rounded-sm`}
                style={{
                  background: "var(--primary-light)",
                }}
              />
              <p>Cash out</p>
            </div>
          </div>
        </div>
      </Card>
      <div className={tw`h-[600px]  bg-white w-full`}>
        <ResponsiveBar
          colors={["var(--primary, #4e4e4e)", "var(--primary-light, #949494)"]}
          colorBy="id"
          margin={{ top: 20, right: 130, bottom: 80, left: 80 }}
          padding={0.3}
          data={data}
          keys={["cash_in", "cash_out"]}
          groupMode="grouped"
          theme={graphTheme}
          valueScale={{ type: "linear" }}
          indexBy="day"
        />
      </div>
    </div>
  );
}
